/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type Maybe from 'graphql/tsutils/Maybe';

import { breakpoints } from '@coursera/cds-core';

import type {
  EntWebsiteBlockTwoColumnsQuery,
  EntWebsiteH1H2CtaFragment,
  EntWebsitePlanCardsColumnFragment,
  EntWebsiteTwoColumnsFragment,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import EntWebsiteH1H2Cta from 'bundles/ent-website/components/EntWebsiteH1H2Cta';
import EntWebsitePlanCards from 'bundles/ent-website/components/EntWebsitePlanCards';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import BlockLayout from 'bundles/ent-website/contentful/core/BlockLayout';
import { entWebsiteBlockTwoColumnsQuery } from 'bundles/ent-website/queries/EntWebsiteTwoColumns';
import withBlockQuery from 'bundles/ent-website/utils/withBlockQuery';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';

const styles = {
  container: () => css`
    ${breakpoints.down('sm')} {
      .BlockLayout_Container {
        padding-top: 32px;
      }
    }
    ${breakpoints.up('md')} {
      .BlockLayout-contentGrid {
        padding-inline-end: 12px;
      }

      .BlockLayout-imageGrid {
        padding-inline-start: 12px;
      }
    }
  `,
};

type Props = BlockModuleInnerProps<EntWebsiteTwoColumnsFragment>;

type ColumnType = Maybe<EntWebsiteH1H2CtaFragment | EntWebsitePlanCardsColumnFragment>;

function Column({ content }: { content: ColumnType }) {
  const renderColumn = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>(() => {
    switch (content?.__typename) {
      case 'EntWebsiteH1H2Cta':
        return <EntWebsiteH1H2Cta content={content} />;
      case 'EntWebsitePlanCardsColumn':
        return <EntWebsitePlanCards content={content} />;
      default:
        return null;
    }
  }, [content]);

  return renderColumn();
}

export function TwoColumnsModule({ content, assembly = {} }: Props) {
  if (!content) return null;

  const { visibility } = assembly;

  const { leftColumn, rightColumn } = content;

  return (
    <div css={styles.container}>
      <BlockLayout
        assembly={assembly}
        renderContent={() => (visibility?.leftColumn ? <Column content={leftColumn} /> : null)}
        renderImage={() => (visibility?.rightColumn ? <Column content={rightColumn} /> : null)}
      />
    </div>
  );
}

// @ts-expect-error TSMIGRATION-5.0 TS2344
export const BlockTwoColumnsModule = withBlockQuery<EntWebsiteTwoColumnsFragment, EntWebsiteBlockTwoColumnsQuery>(
  entWebsiteBlockTwoColumnsQuery
)(TwoColumnsModule);
